import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { appPath } from "../../../utils/appPaths";

export default function ContributorRowActions({ contributor, onEdit }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const closeAndRun = (handler) => {
    setOpen(false);
    handler?.();
  };

  return (
    <Dropdown
      isOpen={open}
      toggle={() => setOpen((value) => !value)}
      className="ctr-actions-menu"
    >
      <DropdownToggle size="sm" color="light" caret className="ctr-actions-menu__toggle">
        Actions
      </DropdownToggle>
      <DropdownMenu end className="ctr-actions-menu__list">
        <DropdownItem
          onClick={() =>
            closeAndRun(() => navigate(appPath(`/contributors/${contributor.id}`)))
          }
        >
          <i className="fa fa-user me-2" />
          View profile
        </DropdownItem>
        <DropdownItem onClick={() => closeAndRun(() => onEdit(contributor))}>
          <i className="fa fa-pencil me-2" />
          Edit bank info
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
